import React from 'react'

import Icon from 'src/components/ui/Icon/Icon'

import styles from './DocumentationIcon.module.scss'

const DocumentationIcon = () => {
  return (
    <div className={styles.icon}>
      <Icon name='document' />
    </div>
  )
}

export default DocumentationIcon
